/**
 * Central experiment configuration.
 * Source of truth for all AB test definitions.
 *
 * To add a new experiment:
 * 1. Add an entry here with variants and default
 * 2. Create the matching experiment in Amplitude dashboard
 * 3. Use <Experiment name="..."> in your component
 */
export const EXPERIMENTS = {
  'home-hero-text': {
    variants: ['control', 'variant-b'],
    default: 'control',
  },
  'app-ab-testing': {
    variants: ['control', 'variant-b'],
    default: 'control',
  },
} as const;
